import React from "react";

const AutomaticDrawerIcon = props => {
    const { fill } = props;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 469.333 469.333" fill={fill}>
<g>
	<g>
		<g>
			<path d="M267.208,380.875l29.188-29.208c2.333-2.333,3.458-5.615,3.042-8.875c-0.5-4.01-0.771-8.052-0.771-12.125
				c0-52.938,43.063-96,96-96c5.896,0,10.667-4.771,10.667-10.667V42.667C405.333,19.135,386.188,0,362.667,0h-128
				c-12.801,0-24.172,5.785-32,14.746C194.839,5.785,183.467,0,170.667,0h-128C19.146,0,0,19.135,0,42.667v298.667
				C0,364.865,19.146,384,42.667,384h128c12.801,0,24.172-5.785,32-14.746c7.828,8.961,19.199,14.746,32,14.746h25
				C262.5,384,265.208,382.875,267.208,380.875z M74.667,64h64c5.896,0,10.667,4.771,10.667,10.667s-4.771,10.667-10.667,10.667h-64
				C68.771,85.333,64,80.562,64,74.667S68.771,64,74.667,64z M138.667,128h-64C68.771,128,64,123.229,64,117.333
				c0-5.896,4.771-10.667,10.667-10.667h64c5.896,0,10.667,4.771,10.667,10.667C149.333,123.229,144.562,128,138.667,128z
				 M170.667,202.667c0,5.896-4.771,10.667-10.667,10.667c-5.896,0-10.667-4.771-10.667-10.667v-21.333
				c0-5.896,4.771-10.667,10.667-10.667c5.896,0,10.667,4.771,10.667,10.667V202.667z M352,170.667
				c5.896,0,10.667,4.771,10.667,10.667v21.333c0,5.896-4.771,10.667-10.667,10.667c-5.896,0-10.667-4.771-10.667-10.667v-21.333
				C341.333,175.437,346.104,170.667,352,170.667z M266.667,64h64c5.896,0,10.667,4.771,10.667,10.667s-4.771,10.667-10.667,10.667
				h-64c-5.896,0-10.667-4.771-10.667-10.667S260.771,64,266.667,64z M256,117.333c0-5.896,4.771-10.667,10.667-10.667h64
				c5.896,0,10.667,4.771,10.667,10.667c0,5.896-4.771,10.667-10.667,10.667h-64C260.771,128,256,123.229,256,117.333z"></path>
            <path d="M394.667,256C353.5,256,320,289.5,320,330.667c0,8.031,1.313,15.958,3.938,23.646l-64.813,64.813
				c-2,2-3.125,4.708-3.125,7.542v32c0,5.896,4.771,10.667,10.667,10.667h32c2.833,0,5.542-1.125,7.542-3.125l64.813-64.802
				c7.688,2.604,15.604,3.927,23.646,3.927c41.167,0,74.667-33.5,74.667-74.667S435.833,256,394.667,256z M405.333,341.333
				C393.563,341.333,384,331.76,384,320c0-11.76,9.563-21.333,21.333-21.333s21.333,9.573,21.333,21.333
				C426.667,331.76,417.104,341.333,405.333,341.333z"></path>
		</g>
	</g>
</g>
            <g>
</g>
            <g>
</g>
            <g>
</g>
            <g>
</g>
            <g>
</g>
            <g>
</g>
            <g>
</g>
            <g>
</g>
            <g>
</g>
            <g>
</g>
            <g>
</g>
            <g>
</g>
            <g>
</g>
            <g>
</g>
            <g>
</g>
</svg>
    );
}

export default AutomaticDrawerIcon;
